/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CkRichTextSectionFragment } from "@cosmos/hygraph-schema";
import { BackgroundContainer, ResponsiveContainer, SectionContainer, CosmosRichText } from "@components/elements";
import { closeRichTextHeadingGaps } from "@components/elements/atoms/text/text.utils";
import { extractBackgroundContainerProps, extractSectionContainerProps } from "@components/utils/section.utils";
import { richTextContentStyles } from "./rich-text.section.styles";
import { RichTextButtons, RichTextHeading, RichTextStack } from "./rich-text.section.common";

export const CkRichTextSection = ({
	config,
	ckContent,
	centered = false,
	wide = false,
	centeredButton = false,
	buttons = [],
}: CkRichTextSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(ckContent || buttons?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)}>
			<ResponsiveContainer>
				<SectionContainer {...extractSectionContainerProps(config)} className="ck-rich-text-section">
					<RichTextStack wide={wide} centered={centered || false}>
						{validHeading ? <RichTextHeading heading={config?.heading} centered={centered || false} /> : null}
						{validContent ? (
							<>
								<div className={richTextContentStyles}>
									{/* Authored legal/long-form HTML often jumps h1→h3 (skips h2); close the gaps
									    (aria-level only, tags/visuals unchanged) so the outline has no skips. */}
									<CosmosRichText html={closeRichTextHeadingGaps(ckContent)} />
								</div>
								<RichTextButtons buttons={buttons} centeredButton={centeredButton} component="CkRichTextSection" />
							</>
						) : null}
					</RichTextStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
